<div class="as-menu__play">
  <li class="readButtons" [asgClickHandler]="moveBackward" asgTooltip="READER_CONTROLS.PREV_UNIT"
    [ngClass]="{'locked': readingIsLocked}">
    <i class="fas fa-backward"></i>
  </li>
  <!-- asgTooltip="READER_CONTROLS.PLAY" -->
  @if (!isPlaying) {
    <li class="readButtons" [asgClickHandler]="onPlayOrPause"
      [ngClass]="{'locked': readingIsLocked}">
      <i class="fas fa-play"></i>
    </li>
  }
  <!-- asgTooltip="READER_CONTROLS.PAUSE" -->
  @if (isPlaying) {
    <li class="readButtons" [asgClickHandler]="onPlayOrPause"
      [ngClass]="{'locked': readingIsLocked}">
      <i class="fas fa-pause"></i>
    </li>
  }
  <li class="readButtons" [asgClickHandler]="moveForward" asgTooltip="READER_CONTROLS.NEXT_UNIT"
    [ngClass]="{'locked': readingIsLocked}">
    <i class="fas fa-forward"></i>
  </li>
</div>
